module.exports = __webpack_public_path__ + "static/img/0003-A-01.0310c99.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/audioimg/0003-A-01.jpg
// module id = /XTF
// module chunks = 0